export default "__VITE_ASSET__aiM8sluF__"